import { DraggableListChoices } from './types'

export const getListChoicesIds = (listChoices: DraggableListChoices[]) =>
  listChoices.map(choice => choice?.id)
export const getChoiceIndex = (listChoicesIds: string[], id: string) => listChoicesIds.indexOf(id)
